export default __webpack_public_path__ + "static/media/46.03641435.jpg";